import React from 'react';

import { useMode } from './Connectable.hooks';
import { useStyles } from './Themable.hooks';

import UserCreationForm from './components/UserCreationForm';
import UserPreview from './components/UserPreview';

const modeSelector = {
    preview: () => <UserPreview />,
    create: () => <UserCreationForm />,
};

const UserPane = () => {
    const mode = useMode();

    const classes = useStyles();

    return (
        <div className={classes.mainWrapper}>
            {mode && modeSelector[mode] && modeSelector[mode]()}
        </div>
    );
};

export default UserPane;
